import { Link } from "@/common/components/elements/Link";

export const HeaderLink = ({ href, children, ...restProps }) => {
  return (
    <Link href={href} color="text.primary" variant="body1" underline="none" {...restProps}>
      {children}
    </Link>
  );
};
